import { FunctionComponent } from "react";
import Profile from "components/shared/Profile";

export interface BankProps {
  accountName: string;
  accountNumber: string;
  sortCode: string;
}

const Bank: FunctionComponent<BankProps> = function ({
  accountName,
  accountNumber,
  sortCode,
}) {
  return (
    <Profile.Section title="Bank details">
      <Profile.Property label="Account name" value={accountName} />
      <Profile.Property label="Account number" value={accountNumber} />
      <Profile.Property label="Sort code" value={sortCode} />
    </Profile.Section>
  );
};

export default Bank;
